import { usePurgeDeletesMutation } from '@forge/graphql/generated'
import { useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

gql`
  mutation purgeDeletes($resourceGroupId: ID!) {
    purgeDeletes(resource_group_id: $resourceGroupId)
  }
`

export function useResourceGroupPurge() {
  const queryClient = useQueryClient()
  return usePurgeDeletesMutation({
    onSuccess() {
      queryClient.invalidateQueries(['purgeDeletes'])
    },
    onError(error) {
      console.error('ERROR PURGING RECORDS', error)
    }
  })
}
